// extracted by mini-css-extract-plugin
module.exports = {"iconSvgWrapper":"_2qeNBA","iconSvg":"_2nMgVy"};